<template>
  <div>
 
  <InventarioActualIngAgrupadoView :id_puesto="store.state.puestoSelect.id_puesto" />
</div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiPoll, mdiLabelVariantOutline, mdiCurrencyUsd, mdiHelpCircleOutline } from '@mdi/js'
import InventarioActualIngAgrupadoView from './InventarioActualIngAgrupadoView.vue'
import store from '@/store'
// demos

export default {
  components: { InventarioActualIngAgrupadoView },
  setup() {
    return {store}
  },
}
</script>
